import "./slick";
import "./slick.css";
import "./slick-theme.css";
import "./index.scss";
import Sloth from "../Sloth";

@Sloth.component({
    defaultOptions : {}
})

export default class Slick {
    onInit() {
        const dom = this.dom;

        $(dom).slick({
            dots: false,
            adaptiveHeight: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1
        }).on("afterChange", (evt, slick, index) => {
            $(".slick-slide", dom).eq(index).addClass("current")
        });

        $(dom).on("click", "video", function () {

            if($(this).parents(".slick-active").length === 0) return;

            if ($(this).parent().hasClass("active")) {
                $(this).parent().removeClass("active");
                this.pause();
            } else {
                $(this).parent().addClass("active");
                this.play();
            }
        })

        $(dom).on("play", "video", function () {
            console.log(111)
        })
    }
}



/** WEBPACK FOOTER **
 ** ./components/Slick/index.js
 **/